module.exports = "/wp-content/themes/conversion/public/dist//svgs/done.svg";